import { ContainerAnalyticsController } from './ContainerAnalyticsController';
import { ContainerNavigationController } from './ContainerNavigationController';
import { ContainerResizeController } from './ContainerResizeController';
import { ContainerExternalStylesController } from './ContainerExternalStylesController';
import { MessageTypes } from '../constants/MessageTypes';
import { createQueue } from '../helpers/createQueue';
import { createEventEmitter } from '../iframe-communication/EventEmitter';
export class ContainerApplicationController {
  // Uses to add delegates for messages from main frame

  constructor({
    ContainerResizeControllerClass = ContainerResizeController
  } = {}) {
    this.queue = createQueue();
    this.gates = [];
    this.gatesHydrated = false;
    this.gatedCallbackQueue = [];
    this.eventEmitter = createEventEmitter();
    this.initPort = e => {
      if (e.data.type !== MessageTypes.INIT) {
        return;
      }
      this.port = e.ports[0];
      this.port.onmessage = this.handleMessage;
      window.removeEventListener('message', this.initPort);
      this.flushQueue();
    };
    this.handleMessage = event => {
      const message = event.data;
      this.receivedMessage(message);
      this.eventEmitter.emit(message.type, message.payload);
    };
    this.handleIfUngated = (gate, callback) => {
      const callbackFunction = () => {
        if (this.isUngatedFor(gate)) {
          callback();
        }
      };
      if (!this.gatesHydrated) {
        this.gatedCallbackQueue.push(callbackFunction);
      } else {
        callbackFunction();
      }
    };
    this.isUngatedFor = gate => {
      return this.gates.includes(gate);
    };
    this.listenForPort();
    this.setRegisterHandlers();
    this.analyticsController = new ContainerAnalyticsController({
      applicationController: this
    });
    this.navigationController = new ContainerNavigationController({
      applicationController: this
    });
    this.resizeController = new ContainerResizeControllerClass({
      applicationController: this
    });
    this.externalStylesController = new ContainerExternalStylesController({
      applicationController: this
    });
  }
  listenForPort() {
    window.addEventListener('message', this.initPort);
  }
  setGates(gates = []) {
    this.gates = gates;
    this.gatesHydrated = true;
    this.gatedCallbackQueue.forEach(callback => callback());
  }
  sendMessage(message) {
    if (!this.port) {
      this.queue.enqueue(message);
      return;
    }
    this.port.postMessage(message);
  }
  fireContainerReady() {
    const payload = this.getStartedMessagePayload();
    this.sendMessage({
      type: MessageTypes.STARTED,
      payload
    });
  }
  navigatePage(url) {
    this.navigationController.navigatePage(url);
  }
  setRegisterHandlers() {
    const handlers = this.registerMessageHandlers();
    Object.keys(handlers).forEach(key => {
      const event = key;
      const handler = handlers[event];
      if (handler) {
        this.registerHandler(event, handler);
      }
    });
  }
  flushQueue() {
    do {
      const message = this.queue.dequeue();
      if (message) {
        this.sendMessage(message);
      }
    } while (this.queue.peek());
  }
  registerHandler(messageType, handler) {
    this.eventEmitter.on(messageType, handler);
  }

  // Override methods
  receivedMessage(__data) {}
  registerMessageHandlers() {
    return {};
  }
  onLinkClick(__linkEl) {}
  getStartedMessagePayload() {
    return {};
  }
}